var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "inspector" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.active != null
        ? _c(
            "nav",
            { staticClass: "navbar fixed-top-sub navbar-light bg-light" },
            [
              _c("div", { staticClass: "navbar-brand" }, [_vm._v("Inspector")]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "nav-item btn-group dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn-block btn dropdown-toggle btn-secondary text-right",
                    staticStyle: { "margin-right": "10px" },
                    attrs: {
                      type: "button",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.active.account_name || _vm.active.account) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "dropdown-menu dropdown-menu-right scrollable-menu"
                  },
                  [
                    _c("h6", { staticClass: "dropdown-header" }, [
                      _vm._v("Accounts")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.inspector, function(report) {
                      return _c("div", { key: _vm.accountKey(report) }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function($event) {
                                return _vm.setActive(report)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.accountLabel(report)))]
                        )
                      ])
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary text-right",
                  attrs: { type: "button" },
                  on: { click: _vm.downloadCSV }
                },
                [_vm._v("Download Report")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.active != null
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-3" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("transition", { attrs: { name: "fade", appear: "" } }, [
                    _c("div", { staticClass: "card col" }, [
                      _c("div", { staticClass: "card-heading" }, [
                        _c("h4", [_vm._v("Account")])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("dl", [
                          _c("dt", [_vm._v("Contract")]),
                          _c("dd", [_vm._v(_vm._s(_vm.active.contract))]),
                          _vm._v(" "),
                          _c("dt", [_vm._v("Account Name")]),
                          _c("dd", [_vm._v(_vm._s(_vm.active.account_name))]),
                          _vm._v(" "),
                          _c("dt", [_vm._v("Account Id")]),
                          _c("dd", [_vm._v(_vm._s(_vm.active.account))]),
                          _vm._v(" "),
                          _c("dt", [_vm._v("Total Findings")]),
                          _c("dd", [_vm._v(_vm._s(_vm.totalFindings))]),
                          _vm._v(" "),
                          _c("dt", [_vm._v("Last Updated")]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(_vm.formatTimestamp(_vm.active.timestamp))
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("transition", { attrs: { name: "fade", appear: "" } }, [
                    _c("div", { staticClass: "card col" }, [
                      _c("div", { staticClass: "card-heading" }, [
                        _c("h4", [_vm._v("Severity Breakdown")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        _vm._l(_vm.severityOrder, function(sev) {
                          return _c(
                            "div",
                            { key: sev, staticClass: "severity-bar" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "severity-label",
                                  class: "severity-" + sev.toLowerCase()
                                },
                                [_vm._v(_vm._s(sev))]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "severity-count" }, [
                                _vm._v(_vm._s(_vm.severityCounts[sev] || 0))
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.activeFinding != null
                ? _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "fade", appear: "" } },
                        [
                          _c("div", { staticClass: "card col" }, [
                            _c("div", { staticClass: "card-heading" }, [
                              _c("h4", [_vm._v("Finding Detail")])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "card-body finding-detail" },
                              [
                                _c("dl", [
                                  _c("dt", [_vm._v("Severity")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _c(
                                      "span",
                                      {
                                        class:
                                          "severity-badge severity-" +
                                          _vm.activeFinding.severity.toLowerCase()
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.activeFinding.severity)
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dt", [_vm._v("Type")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(_vm._s(_vm.activeFinding.type))
                                  ]),
                                  _vm._v(" "),
                                  _c("dt", [_vm._v("Score")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(_vm.activeFinding.inspectorScore)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.activeFinding.packageVulnerability &&
                                  _vm.activeFinding.packageVulnerability
                                    .vulnerabilityId
                                    ? _c("dt", [_vm._v("CVE")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.activeFinding.packageVulnerability &&
                                  _vm.activeFinding.packageVulnerability
                                    .vulnerabilityId
                                    ? _c("dd", [
                                        _vm.activeFinding.packageVulnerability
                                          .sourceUrl
                                          ? _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    _vm.activeFinding
                                                      .packageVulnerability
                                                      .sourceUrl,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.activeFinding
                                                      .packageVulnerability
                                                      .vulnerabilityId
                                                  )
                                                )
                                              ]
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.activeFinding
                                                    .packageVulnerability
                                                    .vulnerabilityId
                                                )
                                              )
                                            ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("dt", [_vm._v("Fix Available")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.activeFinding.fixAvailable || "N/A"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dt", [_vm._v("Exploit Available")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.activeFinding.exploitAvailable ||
                                          "N/A"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.activeFinding.epssScore != null
                                    ? _c("dt", [_vm._v("EPSS")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.activeFinding.epssScore != null
                                    ? _c("dd", [
                                        _vm._v(
                                          _vm._s(_vm.activeFinding.epssScore)
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("dt", [_vm._v("Resource")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.activeFinding.resourceName ||
                                          _vm.activeFinding.resourceId
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dt", [_vm._v("Region")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(_vm.activeFinding.resourceRegion)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dt", [_vm._v("First Observed")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(_vm.activeFinding.firstObservedAt)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("dt", [_vm._v("Last Observed")]),
                                  _vm._v(" "),
                                  _c("dd", [
                                    _vm._v(
                                      _vm._s(_vm.activeFinding.lastObservedAt)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.activeFinding.cvssDetails
                                  ? _c(
                                      "div",
                                      { staticClass: "detail-section" },
                                      [
                                        _c("h5", [_vm._v("CVSS Score")]),
                                        _vm._v(" "),
                                        _c("dl", [
                                          _c("dt", [_vm._v("Score")]),
                                          _vm._v(" "),
                                          _c("dd", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.activeFinding.cvssDetails
                                                  .score
                                              ) +
                                                " (" +
                                                _vm._s(
                                                  _vm.activeFinding.cvssDetails
                                                    .source
                                                ) +
                                                ")"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("dt", [_vm._v("Version")]),
                                          _vm._v(" "),
                                          _c("dd", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.activeFinding.cvssDetails
                                                  .version
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.activeFinding.cvssDetails
                                            .scoringVector
                                            ? _c("dt", [_vm._v("Vector")])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.activeFinding.cvssDetails
                                            .scoringVector
                                            ? _c(
                                                "dd",
                                                { staticClass: "vector-text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.activeFinding
                                                        .cvssDetails
                                                        .scoringVector
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.activeFinding.description
                                  ? _c(
                                      "div",
                                      { staticClass: "detail-section" },
                                      [
                                        _c("h5", [_vm._v("Description")]),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "description-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.activeFinding.description
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.remediationText
                                  ? _c(
                                      "div",
                                      { staticClass: "detail-section" },
                                      [
                                        _c("h5", [_vm._v("Remediation")]),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "description-text" },
                                          [_vm._v(_vm._s(_vm.remediationText))]
                                        ),
                                        _vm._v(" "),
                                        _vm.remediationUrl
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "btn btn-sm btn-outline-primary",
                                                attrs: {
                                                  href: _vm.remediationUrl,
                                                  target: "_blank"
                                                }
                                              },
                                              [_vm._v("More Info")]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.activeFinding.packageVulnerability &&
                                _vm.activeFinding.packageVulnerability
                                  .vulnerablePackages &&
                                _vm.activeFinding.packageVulnerability
                                  .vulnerablePackages.length
                                  ? _c(
                                      "div",
                                      { staticClass: "detail-section" },
                                      [
                                        _c("h5", [_vm._v("Package Versions")]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.activeFinding.packageVulnerability
                                            .vulnerablePackages,
                                          function(pkg, idx) {
                                            return _c(
                                              "div",
                                              {
                                                key: idx,
                                                staticClass: "package-item"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "package-name"
                                                  },
                                                  [_vm._v(_vm._s(pkg.name))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "package-versions"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "version-installed"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(pkg.version)
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    pkg.fixedInVersion
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "version-arrow"
                                                          },
                                                          [_vm._v("→")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    pkg.fixedInVersion
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "version-fixed"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                pkg.fixedInVersion
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                pkg.packageManager
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "package-manager"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            pkg.packageManager
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-9" },
              [
                _c(
                  "transition",
                  { attrs: { name: "fade", appear: "" } },
                  [
                    _c(
                      "vue-good-table",
                      {
                        attrs: {
                          columns: _vm.findingsColumns,
                          rows: _vm.activeFindings,
                          "search-options": {
                            enabled: true,
                            skipDiacritics: true,
                            placeholder: "filter findings"
                          },
                          "pagination-options": {
                            enabled: true,
                            perPage: 25
                          },
                          "sort-options": {
                            enabled: true,
                            initialSortBy: {
                              field: "inspectorScore",
                              type: "desc"
                            }
                          },
                          "row-style-class": _vm.rowStyleClassFn,
                          styleClass: "vgt-table condensed"
                        },
                        on: { "on-row-click": _vm.onRowClick }
                      },
                      [
                        _c(
                          "div",
                          {
                            attrs: { slot: "table-actions" },
                            slot: "table-actions"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-margin btn-sm",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.filterBySeverity("CRITICAL")
                                  }
                                }
                              },
                              [_vm._v("Critical")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-warning btn-margin btn-sm",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.filterBySeverity("HIGH")
                                  }
                                }
                              },
                              [_vm._v("High")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info btn-margin btn-sm",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.filterBySeverity("MEDIUM")
                                  }
                                }
                              },
                              [_vm._v("Medium")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-success btn-margin btn-sm",
                                attrs: { type: "button" },
                                on: { click: _vm.showAllFindings }
                              },
                              [_vm._v("Show All")]
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && _vm.inspector.length === 0
        ? _c("div", { staticClass: "row empty-state" }, [_vm._m(1)])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "nav nav-pages mr-auto" }, [
      _c("li", { staticClass: "nav-item" }, [
        _c("a", { staticClass: "nav-link active", attrs: { type: "button" } }, [
          _vm._v("Findings")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col text-center" }, [
      _c("h4", [_vm._v("No Inspector findings available")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Inspector data will appear here once the feature is deployed and findings are reported."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ced2a2a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ced2a2a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Inspector.vue
// module id = null
// module chunks = 